import { render } from "./DictionaryList.vue?vue&type=template&id=24e667e4"
import script from "./DictionaryList.vue?vue&type=script&lang=js"
export * from "./DictionaryList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__